import { SectionConfig } from '.';

export const messageCustomizationConfig: SectionConfig[] = [
  {
    id: 'colors',
    title: 'Chat Colors',
    fields: [
      { key: 'user_color', label: 'User Background Color', type: 'color' },
      { key: 'char_color', label: 'Character Background Color', type: 'color' },
      { key: 'userTextColor', label: 'User Text Color', type: 'color' },
      { key: 'charTextColor', label: 'Character Text Color', type: 'color' },
      { key: 'userItalicColor', label: 'User Italic Color', type: 'color' },
      {
        key: 'charItalicColor',
        label: 'Character Italic Color',
        type: 'color',
      },
      { key: 'userQuotedColor', label: 'User Quoted Color', type: 'color' },
      {
        key: 'charQuotedColor',
        label: 'Character Quoted Color',
        type: 'color',
      },
    ],
    defaultValues: {
      user_color: '#555555',
      char_color: 'rgba(20,24,28,0.6)',
      userTextColor: '#FFFFFF',
      charTextColor: '#FFFFFF',
      userItalicColor: '#999999',
      charItalicColor: '#999999',
      userQuotedColor: '#AAAAAA',
      charQuotedColor: '#93BEE6',
    },
  },
  {
    id: 'avatars',
    title: 'Avatars',
    fields: [
      { key: 'userAvatar', label: 'User Avatar URL', type: 'text' },
      { key: 'charAvatar', label: 'Character Avatar URL', type: 'text' },
    ],
    defaultValues: {
      userAvatar: 'https://api.dicebear.com/8.x/thumbs/svg?seed=UserExample',
      charAvatar: 'https://api.dicebear.com/8.x/thumbs/svg?seed=CharExample',
    },
  },
  {
    id: 'typingIndicator',
    title: 'Typing Indicator',
    fields: [
      { key: 'symbol', label: 'Indicator Symbol', type: 'text' },
      {
        key: 'speed',
        label: 'Typing Speed (ms per dot)',
        type: 'number',
        min: 50,
        max: 500,
        step: 10,
      },
      {
        key: 'repeat',
        label: 'Number of Dots',
        type: 'number',
        min: 1,
        max: 10,
        step: 1,
      },
      {
        key: 'dotSize',
        label: 'Dot Size (px)',
        type: 'number',
        min: 4,
        max: 20,
        step: 1,
      },
      { key: 'dotColor', label: 'Dot Color', type: 'color' },
      {
        key: 'animationDuration',
        label: 'Bounce Duration (ms)',
        type: 'number',
        min: 200,
        max: 2000,
        step: 50,
      },
    ],
    defaultValues: {
      symbol: '.',
      speed: 250,
      repeat: 3,
      dotSize: 8,
      dotColor: '#333333',
      animationDuration: 1400,
    },
  },
  {
    id: 'displayOptions',
    title: 'Display Options',
    fields: [
      {
        key: 'stripIncompleteOutput',
        label: 'Strip Incomplete Output',
        type: 'json',
      },
    ],
    defaultValues: {
      stripIncompleteOutput: true,
    },
  },
];
